interface DropdownItem {
  label: string
  value: string | number
}

interface PaginationBody {
  pageSize: number,
  pageNumber: number,
  searchValue: string,
  orderBy: string,
  descending: boolean
}

interface Error {
  code?: string,
  message?: string
}

interface FilterOptions {
  config: {
    descending: boolean,
    enabled: boolean
  }
}

type FiltrationItem<T extends string> = {
  [K in T]: FilterOptions
}

export const keys = Object.keys as <T>(o: T) => Extract<keyof T, string>[];

export const values = Object.values as <T>(
  o: T
) => T[Extract<keyof T, string>][];

export const entries = Object.entries as <T>(
  o: T
) => [Extract<keyof T, string>, T[Extract<keyof T, string>]][];

export { DropdownItem, PaginationBody, Error, FiltrationItem }